import React, { ReactNode, useEffect, useRef, useState } from 'react'

import { HiOutlineMenu, HiX } from 'react-icons/hi'

import ShellHeader from './ShellHeader'
import SidebarNavigation from './SidebarNavigation'
import { useUser } from '../../../context'
import { RoleTone } from '../../constants'
import { useRedesignTheme } from '../../theme'

import { Frame, MainSurface, MenuToggle } from './styles'

interface AppShellProps {
  children: ReactNode
}

const AppShell = ({ children }: AppShellProps) => {
  const { userRole } = useUser()
  const { resolvedTheme } = useRedesignTheme()
  const [menuOpen, setMenuOpen] = useState(false)
  const menuTriggerRef = useRef<HTMLButtonElement | null>(null)
  const role = (userRole || 'student') as RoleTone

  useEffect(() => {
    if (!menuOpen) return

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return
      setMenuOpen(false)
      requestAnimationFrame(() => menuTriggerRef.current?.focus())
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [menuOpen])

  const closeMobileMenu = () => {
    if (window.innerWidth <= 480) setMenuOpen(false)
  }

  return (
    <Frame $role={role} data-redesign-theme={resolvedTheme}>
      <MenuToggle
        ref={menuTriggerRef}
        type="button"
        $open={menuOpen}
        aria-label={menuOpen ? 'Cerrar menú principal' : 'Abrir menú principal'}
        aria-expanded={menuOpen}
        aria-controls="redesign-primary-navigation"
        onClick={() => setMenuOpen((value) => !value)}
      >
        {menuOpen ? (
          <HiX aria-hidden="true" />
        ) : (
          <HiOutlineMenu aria-hidden="true" />
        )}
      </MenuToggle>

      <SidebarNavigation
        open={menuOpen}
        role={role}
        onNavigate={closeMobileMenu}
      />

      <MainSurface $role={role}>
        <ShellHeader />
        {children}
      </MainSurface>
    </Frame>
  )
}

export default AppShell
